export default __webpack_public_path__ + "static/media/RemoteNoBrand.f7f55713.png";